<template>
<div class="MediaMatrix">
    <Media></Media>
</div>
</template>

<script>
import Media from 'base/media/Media'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MediaMatrix',
    data() {
        return {}
    },
    mounted() {
        $('html').scrollTop(0)
    },
    methods: {
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        Media
    }
}
</script>

<style lang="scss" type="text/scss">
.MediaMatrix {
    background-color: #F8F8F8;
    font-family:PingFangSC-Medium,PingFang SC;
    padding-bottom: 60px;
    display: flex;
    height: 100%;
    // min-height: calc(100vh - 518px);
}
</style>